import React from "react";

interface IconProps {
  size?: number;
  w?: number;
  style?: React.CSSProperties;
  className?: string;
}

function Svg({ size = 18, w = 1.7, style, className, children }: IconProps & { children: React.ReactNode }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth={w} strokeLinecap="round" strokeLinejoin="round"
      style={style} className={className}>
      {children}
    </svg>
  );
}

export const I = {
  radar: (p: IconProps = {}) => <Svg {...p}><path d="M19.07 4.93A10 10 0 1 0 22 12" /><path d="M12 12 19 5" /><path d="M12 7a5 5 0 1 0 5 5" /><circle cx={12} cy={12} r={1.4} fill="currentColor" stroke="none" /></Svg>,
  pipeline: (p: IconProps = {}) => <Svg {...p}><rect x={3} y={4} width={5} height={16} rx={1} /><rect x={10} y={4} width={5} height={10} rx={1} /><rect x={17} y={4} width={4} height={13} rx={1} /></Svg>,
  principals: (p: IconProps = {}) => <Svg {...p}><path d="M3 21h18" /><rect x={5} y={8} width={6} height={13} rx={1} /><rect x={13} y={4} width={6} height={17} rx={1} /><path d="M7.5 11.5v0M7.5 14.5v0M16 7.5v0M16 11v0" /></Svg>,
  signal: (p: IconProps = {}) => <Svg {...p}><path d="M4 18V9M9 18v-6M14 18V6M19 18v-9" /></Svg>,
  globe: (p: IconProps = {}) => <Svg {...p}><circle cx={12} cy={12} r={9} /><path d="M3 12h18" /><path d="M12 3a14 14 0 0 1 0 18a14 14 0 0 1 0-18" /></Svg>,
  search: (p: IconProps = {}) => <Svg {...p}><circle cx={11} cy={11} r={7} /><path d="m20 20-3.2-3.2" /></Svg>,
  arrowUpRight: (p: IconProps = {}) => <Svg {...p}><path d="M7 17 17 7M8 7h9v9" /></Svg>,
  arrowRight: (p: IconProps = {}) => <Svg {...p}><path d="M5 12h14M13 6l6 6-6 6" /></Svg>,
  flame: (p: IconProps = {}) => <Svg {...p}><path d="M12 3c2 3 4.5 4.5 4.5 8a4.5 4.5 0 0 1-9 0c0-1.4.6-2.4 1.3-3.2C9.5 9 10 10 10.2 10.6 11 9 11.5 6 12 3Z" /></Svg>,
  clock: (p: IconProps = {}) => <Svg {...p}><circle cx={12} cy={12} r={9} /><path d="M12 7v5l3 2" /></Svg>,
  check: (p: IconProps = {}) => <Svg {...p}><path d="M20 6 9 17l-5-5" /></Svg>,
  doc: (p: IconProps = {}) => <Svg {...p}><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" /><path d="M14 3v5h5" /></Svg>,
  mail: (p: IconProps = {}) => <Svg {...p}><rect x={3} y={5} width={18} height={14} rx={2} /><path d="m3 7 9 6 9-6" /></Svg>,
  phone: (p: IconProps = {}) => <Svg {...p}><path d="M5 4h4l2 5-3 2a12 12 0 0 0 5 5l2-3 5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2" /></Svg>,
  note: (p: IconProps = {}) => <Svg {...p}><path d="M4 5h16M4 10h16M4 15h10" /></Svg>,
  meeting: (p: IconProps = {}) => <Svg {...p}><circle cx={9} cy={8} r={3} /><path d="M3 20a6 6 0 0 1 12 0" /><circle cx={17} cy={9} r={2.2} /><path d="M16 20a5 5 0 0 1 5-2" /></Svg>,
  plus: (p: IconProps = {}) => <Svg {...p}><path d="M12 5v14M5 12h14" /></Svg>,
  chevron: (p: IconProps = {}) => <Svg {...p}><path d="m9 6 6 6-6 6" /></Svg>,
  chevronDown: (p: IconProps = {}) => <Svg {...p}><path d="m6 9 6 6 6-6" /></Svg>,
  filter: (p: IconProps = {}) => <Svg {...p}><path d="M3 5h18l-7 8v5l-4 2v-7z" /></Svg>,
  bell: (p: IconProps = {}) => <Svg {...p}><path d="M18 8a6 6 0 1 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" /><path d="M13.7 21a2 2 0 0 1-3.4 0" /></Svg>,
  ext: (p: IconProps = {}) => <Svg {...p}><path d="M15 3h6v6M10 14 21 3M21 14v5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5" /></Svg>,
  sliders: (p: IconProps = {}) => <Svg {...p}><path d="M4 6h10M18 6h2M4 12h2M10 12h10M4 18h7M15 18h5" /><circle cx={16} cy={6} r={2} /><circle cx={8} cy={12} r={2} /><circle cx={13} cy={18} r={2} /></Svg>,
  tasks: (p: IconProps = {}) => <Svg {...p}><path d="M9 6h11M9 12h11M9 18h11" /><path d="M4 6l1.2 1.2L7 5" /><path d="M4 12l1.2 1.2L7 11" /><path d="M4 18l1.2 1.2L7 17" /></Svg>,
  ai: (p: IconProps = {}) => <Svg {...p}><path d="M12 3l1.7 4.8L18.5 9.5 13.7 11.2 12 16l-1.7-4.8L5.5 9.5l4.8-1.7z" /><path d="M18.5 14.5l.6 1.8.8-1.8.8.6-1.8.7 1.8.8-.8.7-.6-1.8z" /></Svg>,
  send: (p: IconProps = {}) => <Svg {...p}><path d="M4 12 20 4l-6 16-3-7z" /><path d="M11 13 20 4" /></Svg>,
  book: (p: IconProps = {}) => <Svg {...p}><path d="M5 4h11a3 3 0 0 1 3 3v13H8a3 3 0 0 0-3 3z" /><path d="M5 4v16" /><path d="M9 8h6M9 12h6" /></Svg>,
  home: (p: IconProps = {}) => <Svg {...p}><path d="M3 12l9-8 9 8" /><path d="M5 10v9a1 1 0 0 0 1 1h4v-5h4v5h4a1 1 0 0 0 1-1v-9" /></Svg>,
  trash: (p: IconProps = {}) => <Svg {...p}><path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6" /><path d="M10 11v6M14 11v6" /></Svg>,
};

export function Beacon({ size = 22, style }: { size?: number; style?: React.CSSProperties }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" style={style}>
      <path d="M12 2.5 14 6.2 10 6.2Z" fill="var(--ember)" />
      <rect x={7.5} y={8} width={9} height={3.1} rx={1.2} fill="currentColor" opacity={0.92} />
      <rect x={6} y={12} width={12} height={3.1} rx={1.2} fill="currentColor" opacity={0.72} />
      <rect x={4.5} y={16} width={15} height={3.1} rx={1.2} fill="currentColor" opacity={0.52} />
    </svg>
  );
}
